<template>
  <div class="row">
    <div class="col-xs-12">
      <h1 class="page-header">Pendências</h1>

      <div class="row">
        <div class="col-xs-12 col-sm-12">
          <list
            ref="escalas"
            :show-empty="true"
            title="Listagem de escalas pendentes"
            reportTitle="Escalas pendentes"
            :has-auth="false"
            :api-mode="false"
            :dados="pendencias"
            :fields="datatable.columns"
            :show-print-button="false"
            :carregando="isLoading"
          >
            <template slot="rowrender" slot-scope="props">
              <div class="">
                <button
                  title="Enviar para análise"
                  class="btn btn-primary"
                  @click="enviarAnalise(props.rowData)"
                >
                 <font-awesome-icon :icon="'paper-plane'"></font-awesome-icon>
                </button>
                <button
                  title="Atualizar a Observação"
                  type="button"
                  class="btn btn-primary"
                  @click="atualizarObservacao(props.rowData)"
                >
                <font-awesome-icon :icon="'exclamation-triangle'" />
                </button>
              </div>
            </template>
          </list>

          <input-modal
            ref="inputModal"
            titulo="Atualizar a observação"
            descricao="Descreva abaixo a observação para está escala"
            label="Observação"
            placeholder="Descreva aqui a observação da escala..."
           />

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import list from '@/components/common/NoApiTable'
import inputModal from '@/components/common/InputModal'

import { request } from '@/request'

export default {
  name: 'escalas-pendentes',
  inject: ["showConfirm"],
  data() {
    return {
      type: 'Pendencias',
      datatable: {
        columnID: 'id',
        columns: [
          {
            name: 'uor_sigla',
            title: 'Unidade',
            dataClass: 'align-middle',
            width: '50px'
          },
          {
            name: 'referencia_label',
            title: 'Competência',
            titleClass: 'text-center',
            dataClass: 'align-middle text-center'
          },
          {
            name: 'total_colaboradores',
            title: 'Total de Colaboradores',
            titleClass: 'text-center',
            dataClass: 'align-middle text-center'
          },
          {
            name: 'observacao',
            title: 'Observação',
            dataClass: 'align-middle text-reduce',
            callback: (text) => (`<span title="${text}">${text || 'Nenhuma'}</span>`)
          },
          { 
            name: '__slot:actions', 
            title: 'Ações', 
            titleClass: 'text-center',
            dataClass: 'align-middle text-center', 
            width: '110px' 
          },
        ],
      },
      pendencias: [],
      isLoading: false
    }
  },
  components: {
    list,
    inputModal
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  created() {
    this.loadPendencias()
  },
  methods: {
    enviarAnalise(data) {
      var config = {
        title: 'Alerta',
        question: true,
        yes: async () => {
          let { uor_sigla, referencia } = data
          
          const { status } = await request.post('escala/analisar', { uor_sigla, referencia })

          if (status === 200) {
            this.$toastr.s('Escala foi enviada para análise!')
            this.loadPendencias()
          } else {
            this.$toastr.e(
                'Houve uma falha ao tentar enviar a escala para análise, favor tentar daqui alguns minutos!'
              )
              console.log(error)
          }
        },
      }
      this.showConfirm(
        'Deseja realmente enviar está escala para análise?',
        config
      )
    },
    atualizarObservacao(data) {
      const me = this
      const requestSalvarObservacao = function (observacao) {
        let { id } = data
          
          request.post('escala/observacao', { id, observacao })
          .then(() => {
            me.$refs.inputModal.hide()
            me.$toastr.s('A observação da Escala foi atualizada!')
            me.loadPendencias()
          })
          .catch(error => {
            me.$toastr.e('Houve uma falha ao tentar atualizar a observação da escala, favor tentar daqui alguns minutos!')
            console.log(error)
          })
      }

      this.$refs.inputModal.show({ value: data.observacao, fnOk: requestSalvarObservacao })
    },
    loadPendencias() {
      this.isLoading = true;

      request.get('escala/listar-pendentes')
      .then(response => { 
        this.pendencias = response.data 
        this.isLoading = false
      })
      .catch(error => {
        console.log(error)
        this.isLoading = false
      })


    }
  },
}
</script>

<style scoped="">
input[type='file'] {
  display: none;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}
</style>

<style>
  .text-reduce {
    cursor: pointer;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    -webkit-border-before: 0px;
    line-height: 26px !important;
    border-top: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/escalas/Pendentes.vue